import { useEffect, useMemo, useRef, useState } from "react";
import { GoogleMap, MarkerF, useJsApiLoader } from "@react-google-maps/api";
import { CarOutlined } from "@ant-design/icons";
import iCar from "../../assets/icons/iCar.png";

const DEFAULT_CENTER = { lat: 47.929239, lng: 106.921784 };
const GOOGLE_MAPS_KEY = process.env.REACT_APP_GOOGLE_MAPS_KEY || "";

function Index(props) {
  const [location, setLocation] = useState(null);
  const mapRef = useRef(null);
  const { imei } = props?.selectedCar || {};
  const isDemo = props?._auth?.user?.phone === "demo";

  const { isLoaded, loadError } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: GOOGLE_MAPS_KEY,
  });

  useEffect(() => {
    if (isDemo) {
      setLocation(DEFAULT_CENTER);
    } else if (
      props?.selectedCar &&
      props?.info?.[imei]?.lattitude &&
      props?.info?.[imei]?.longitude
    ) {
      setLocation({
        lat: Number(props.info[imei].lattitude),
        lng: Number(props.info[imei].longitude),
      });
    } else setLocation(null);
  }, [props?.selectedCar, props?.info]);

  // Байршил өөрчлөгдөхөд газрын зургийг дагуулж төвлөрүүлнэ
  useEffect(() => {
    if (location && mapRef.current) {
      mapRef.current.panTo(location);
    }
  }, [location]);

  const speed = props?.info?.[imei]?.curr_speed || 0;

  const markerIcon = useMemo(() => {
    if (!isLoaded || !window.google) return undefined;
    return {
      url: iCar,
      scaledSize: new window.google.maps.Size(40, 40),
      anchor: new window.google.maps.Point(20, 20),
    };
  }, [isLoaded]);

  const options = useMemo(
    () => ({
      mapTypeId: "hybrid",
      disableDefaultUI: true,
      zoomControl: true,
      gestureHandling: "greedy",
      clickableIcons: false,
    }),
    []
  );

  return (
    <div className="w-full h-full relative rounded-xl overflow-hidden">
      <div className="absolute top-3 right-3 z-10 text-white bg-active px-3 py-2 rounded-full flex items-center justify-center transition-all">
        <CarOutlined className="text-xl" />
        <span className="text-lg ml-2">
          {(Number(speed) || 0)?.toFixed(0)}{" "}
          <span className="text-xs">km/h</span>
        </span>
      </div>

      {loadError ? (
        <div className="w-full h-full flex items-center justify-center text-sm">
          Газрын зураг ачаалахад алдаа гарлаа.
        </div>
      ) : isLoaded ? (
        <GoogleMap
          mapContainerStyle={{ width: "100%", height: "100%" }}
          center={location || DEFAULT_CENTER}
          zoom={16}
          options={options}
          onLoad={(map) => (mapRef.current = map)}
          onUnmount={() => (mapRef.current = null)}
        >
          {props?.selectedCar && location && (
            <MarkerF position={location} icon={markerIcon} />
          )}
        </GoogleMap>
      ) : null}
    </div>
  );
}

export default Index;
